import actionTypes from './actionTypes';

export const start = (manifestOrderId) => ({
  type: actionTypes.START,
  payload: {
    manifestOrderId,
  },
});

export const starting = () => ({
  type: actionTypes.STARTING,
});

export const started = (data) => ({
  type: actionTypes.STARTED,
  payload: {
    data,
  },
});

export const createMW = (data) => ({
  type: actionTypes.CREATE_MW,
  payload: {
    data,
  },
});

export const creatingMW = () => ({
  type: actionTypes.CREATING_MW,
});

export const createdMW = (data) => ({
  type: actionTypes.CREATED_MW,
  payload: {
    data,
  },
});

export const failedToCreateMW = () => ({
  type: actionTypes.FAILED_TO_CREATE_MW,
  payload: {},
});
